import { Heading } from '@acb_devel/design-system';

import styles from './AchievementList.module.scss';

export function AchievementList({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode[] | React.ReactNode;
}) {
  return (
    <div className={styles.list}>
      <Heading as="h4" variant="heading-1" className={styles.list__title}>
        <b>{title}</b>
      </Heading>
      <ul className={styles.list__items}>{children}</ul>
    </div>
  );
}
